import SwipeCardCustom from './SwipeCardCustom';
export default SwipeCardCustom;
